import track from 'react-tracking';
import Modal from '@/components/Modal';
import { TransactionsModalWrapper } from './styled';
import AddTransactions, {
  FetchPriceArgs,
  AddTransactionArgs,
  UpdateReinvestArgs,
} from '@/components/DeprecatedPortfolio/components/TransactionsModal/components/AddTransactions';
import CurrentTransactions from '@/components/DeprecatedPortfolio/components/TransactionsModal/components/CurrentTransactions';
import type {
  TransactionsModalStatusType,
  TransactionsStatusType,
} from '@/components/DeprecatedPortfolio/redux/interface';

interface Transaction {
  transactionAmount: number;
  transactionCost: number;
  transactionDate: number;
  transactionId: string;
  transactionType: string;
  isRemoving?: boolean;
}

export interface TransactionsModalProps {
  portfolioId: string;
  itemId: string;
  companyId: string;
  tickerSymbol: string;
  itemPrices?: Record<string, number>;
  transactions?: Transaction[];
  isUpdatingItemPrice?: boolean;
  isAddingTransaction?: boolean;
  doesPortfolioNeedsRefresh?: boolean;
  reinvestDividends?: boolean;
  isUpdatingReinvest?: boolean;
  transactionsStatus: TransactionsStatusType;
  transactionsModalStatus: TransactionsModalStatusType;
  handleFetchPriceForItem?: (options: FetchPriceArgs) => void;
  onClose: (bool?: boolean) => void;
  handleAddTransaction: (options: AddTransactionArgs) => void;
  handleRemoveTransaction: (data: any) => void;
  handleUpdateReinvest: (options: UpdateReinvestArgs) => void;
  handlePortfolioRefresh: (portfolioId: string | null) => void;
}

const TransactionsModal = ({
  portfolioId,
  itemId,
  companyId,
  tickerSymbol,
  itemPrices,
  transactions,
  isUpdatingItemPrice,
  isAddingTransaction,
  doesPortfolioNeedsRefresh,
  reinvestDividends,
  isUpdatingReinvest,
  handleFetchPriceForItem,
  handleAddTransaction,
  handleRemoveTransaction,
  onClose,
  handleUpdateReinvest,
  transactionsStatus,
  transactionsModalStatus,
  handlePortfolioRefresh,
}: TransactionsModalProps) =>
  transactionsModalStatus === 'visible' ? (
    <Modal
      title={`Edit Transaction (${tickerSymbol})`}
      onClose={() => {
        onClose();
        doesPortfolioNeedsRefresh && handlePortfolioRefresh(portfolioId);
      }}
      hideFooter={true}
      fullscreen={true}
    >
      <TransactionsModalWrapper>
        <AddTransactions
          portfolioId={portfolioId}
          itemId={itemId}
          companyId={companyId}
          tickerSymbol={tickerSymbol}
          itemPrices={itemPrices}
          isFetchingPrice={isUpdatingItemPrice}
          isAddingTransaction={isAddingTransaction}
          reinvestDividends={reinvestDividends}
          isUpdatingReinvest={isUpdatingReinvest}
          handleFetchPrice={handleFetchPriceForItem}
          handleAddTransaction={handleAddTransaction}
          handleUpdateReinvest={handleUpdateReinvest}
        />
        <CurrentTransactions
          portfolioId={portfolioId}
          companyId={companyId}
          itemId={itemId}
          isUpdatingTransaction={transactionsStatus === 'updating'}
          transactions={transactions || []}
          handleRemoveTransaction={handleRemoveTransaction}
        />
      </TransactionsModalWrapper>
    </Modal>
  ) : null;

TransactionsModal.defaultProps = {
  itemPrices: {},
  transactions: [],
  isUpdatingItemPrice: false,
  isAddingTransaction: false,
  doesPortfolioNeedsRefresh: false,
  handleFetchPriceForItem: () => null,
};

export default track({
  type: 'track',
  subject: 'TransactionsModal',
})(TransactionsModal);
